import { render, staticRenderFns } from "./iwleave.vue?vue&type=template&id=ad772c7a&scoped=true&"
import script from "./iwleave.vue?vue&type=script&lang=js&"
export * from "./iwleave.vue?vue&type=script&lang=js&"
import style0 from "./iwleave.vue?vue&type=style&index=0&id=ad772c7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad772c7a",
  null
  
)

export default component.exports